import React from 'react';
import UnderConstruction from '../../../../components/UnderConstruction';
import SharedHeader from '../../../../components/SharedHeader';
import DashboardFooter from '../../../../components/DashboardFooter';
import './our_mentees.css';

// # Our Mentees management component (currently under construction)
const OurMentees = () => {
  return (
    <div className="our_mentees_container">
      <SharedHeader title="Our Mentees" />
      
      <div className="our_mentees_content">
        <UnderConstruction pageName="Mentees Management" />
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default OurMentees;
